"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Palette = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const Verpackung_1 = require("./Verpackung");
const echain_product_models_1 = require("@igus/echain-product-models");
/**
 * The class `Palette` is a Value Object representing an igus Palette article.
 */
class Palette extends Verpackung_1.Verpackung {
    constructor() {
        super(...arguments);
        this.className = 'Palette';
    }
    get laenge() {
        return echain_shared_quantities_1.Q.optional(this.model.Laenge);
    }
    set laenge(value) {
        this.model.Laenge = value === null || value === void 0 ? void 0 : value.quantity;
    }
    get breite() {
        return echain_shared_quantities_1.Q.optional(this.model.Breite);
    }
    set breite(value) {
        this.model.Breite = value === null || value === void 0 ? void 0 : value.quantity;
    }
    static fromScratch() {
        return new Palette({
            ArticleType: echain_product_models_1.ArticleType.verpackung,
            Typ: echain_shared_articles_1.VerpackungType.palette,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Palette.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const palette = Palette.fromJson(args, cloneStrategy);
        palette.artNrExists = true;
        return palette;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Palette.fromInventedArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const palette = Palette.fromJson(args, cloneStrategy);
        palette.artNrExists = false;
        return palette;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        const palette = Palette.fromScratch();
        palette.fromJson(args, cloneStrategy);
        return palette;
    }
    static fromModel(model) {
        const palette = Palette.fromScratch();
        Object.assign(palette.model, model);
        Object.assign(model, palette.model);
        palette.model = model;
        return palette;
    }
    clone() {
        return this._clone(Palette.fromScratch());
    }
    duplicate() {
        return this._duplicate();
    }
    /**
     * Returns the maximal length of a Verpackung or undefined if the maximal length couldn't be
     * calculated.
     */
    getMaxLength() {
        var _a;
        let maxLength = (_a = this.breite) === null || _a === void 0 ? void 0 : _a.clone();
        if (this.laenge && (!maxLength || maxLength.mm < this.laenge.mm)) {
            maxLength = this.laenge.clone();
        }
        return maxLength;
    }
    /**
     * Returns the volume of a Verpackung or undefined if the volume couldn't be calculated.
     */
    getVolume() {
        return undefined;
    }
}
exports.Palette = Palette;
//# sourceMappingURL=Palette.js.map